"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocumentName = void 0;
var getDocumentName = exports.getDocumentName = function getDocumentName(documentName) {
  if (documentName.includes("Originals")) {
    var firstOccurrenceIndex = documentName.indexOf("Originals") + "Originals".length;
    var remainingString = documentName.slice(firstOccurrenceIndex);
    var cleanedRemainingString = remainingString.replace(/Originals/, "");
    documentName = cleanedRemainingString.replace(/^\//, "");
  }
  return "Originals/".concat(documentName);
};